import React, { useState } from "react";
import PopUp from "./PopUp";
import ArrowDropDownCircleOutlinedIcon from "@mui/icons-material/ArrowDropDownCircleOutlined";
import PetDetailsModel from "./PetDetailsModel";
import CareTeamModel from "./CareTeamModel";
import { useNavigate } from "react-router-dom";
import { updateSubscription } from "redux-store/user/user.slice";
import { AppDispatch } from "redux-store/store";
import { useDispatch, useSelector } from "react-redux";
import { getAllTests, resetsubmittedTests } from "redux-store/lab-tests/tests.slice";
import { user } from "redux-store/user/user.selectors";
import ResetModal from "./ResetModal";

type PropsType = {
  result?: any;
  isSubmitted?: boolean;
};

const LabResultMobile = ({ result, isSubmitted }: PropsType) => {
  const [open, setOpen] = useState(false);
  const [showPetModel, setShowPetModel] = React.useState(false);
  const [showVetModel, setShowVetModel] = useState(false);
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();
  const loggedInUser = useSelector(user);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState("Basic");
  const dispatch = useDispatch<AppDispatch>();

  const [isModalOpen, setModalOpen] = useState(false);
  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  const handleResetData = () => {
    dispatch(resetsubmittedTests(result?._id))
      .then(() => {
        setModalOpen(false);
        dispatch(getAllTests({ page: 1 }));
      })
      .catch((error) => {
        console.error("Error resetting data:", error);
      });
  };

  const handleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
    if (result?.kitId?.subscription === "Basic") {
      setSelectedSubscription("Plus");
    } else {
      setSelectedSubscription("Basic");
    }
  };

  const handleSubscriptionSelect = (option: string, kitId: any) => {
    dispatch(updateSubscription({ subscription: option, kitId: kitId })).then((res) => {
      dispatch(getAllTests({ page: 1 }));
    });
    setDropdownOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePetModelClose = () => {
    setShowPetModel(false);
  };
  const handleVetClick = () => {
    setUserId(result.userId._id);
    setShowVetModel(true);
  };

  const reportDownloadHandler = (id: any) => {
    navigate(`/parent-test-result`, { state: result });
  };
  return (
    <div className="tw-w-[80%] tw-mx-auto tw-bg-white tw-py-6 tw-shadow-small tw-rounded-[1rem]">
      <div className="tw-w-[80%] tw-mx-auto tw-flex tw-flex-col tw-gap-3">
        {/* 1st main col */}
        <div className="tw-flex tw-flex-col tw-gap-2">
          {/* 1st col */}
          <div className="tw-flex tw-items-center tw-justify-between">
            <div>
              <span className="tw-font-bold tw-text-base tw-text-darkPurple ">Customer Name</span>
            </div>
            <div>
              <span className="">{result?.userId?.fullName && result.userId.fullName}</span>
            </div>
          </div>
          <hr />
          {/* 2nd col */}
          <div className="tw-flex tw-items-center tw-justify-between">
            <div>
              <span className="tw-font-bold tw-text-base tw-text-darkPurple ">Pet Name</span>
            </div>
            <div className="tw-text-left">
              <span onClick={() => setShowPetModel(true)} className="">
                {result?.petId?.petName}
              </span>
            </div>
          </div>
          <hr />
          {/* 3rd col */}
          <div className="tw-flex tw-items-center tw-justify-between">
            <span className="tw-font-bold tw-text-base tw-text-darkPurple">Risk Level</span>
            <span className="">
              {result.riskLevel ? result.riskLevel : <ArrowDropDownCircleOutlinedIcon onClick={handleClickOpen} />}{" "}
            </span>
          </div>
          <hr />
          {/* 4th col */}
          <div className="tw-flex tw-items-center tw-justify-between">
            <span className="tw-font-bold tw-text-base tw-text-darkPurple">Risk Value</span>
            <span className="">
              {result.riskValue ? result.riskValue : <ArrowDropDownCircleOutlinedIcon onClick={handleClickOpen} />}
            </span>
          </div>
        </div>
        {/* 2nd main col */}
        <div className="tw-w-[80%] tw-gap-2 tw-mx-auto tw-flex tw-items-center tw-justify-center">
          {loggedInUser?.isHospital ? (
            <div className="tw-flex tw-flex-1 tw-gap-2">
              <div className="tw-w-[80%] tw-gap-2 tw-mx-auto tw-flex tw-items-center tw-justify-center">
                <button
                  className="tw-flex tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-[#FF7B6D] tw-py-2 tw-px-8 tw-rounded-md"
                  onClick={() => reportDownloadHandler(result?._id)}
                >
                  Download
                </button>
              </div>
            </div>
          ) : (
            <div className="tw-flex tw-flex-1 tw-gap-2">
              <div className="tw-flex tw-items-center">
                {isSubmitted && (
                  <>
                    <button className="tw-text-[#FF7B6D] tw-underline" onClick={handleOpenModal}>
                      Reset
                    </button>
                    <div className="">
                      <ResetModal isOpen={isModalOpen} onClose={handleCloseModal} onConfirm={handleResetData} />
                    </div>
                  </>
                )}
              </div>
              {isSubmitted ? (
                <button className="tw-flex tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-[#FF7B6D] tw-py-2 tw-px-8 tw-rounded-md">
                  Submitted
                </button>
              ) : (
                <button
                  className="tw-flex tw-items-center tw-justify-center tw-text-lg tw-text-[#000] tw-font-bold tw-py-1 tw-px-5 tw-rounded-lg tw-border-black tw-border-2"
                  onClick={handleClickOpen}
                >
                  Submit
                </button>
              )}
              <div>
                <button
                  onClick={handleVetClick}
                  className="tw-flex tw-items-center tw-justify-center tw-text-lg tw-text-[#000] tw-font-bold tw-py-1 tw-px-5 tw-rounded-lg tw-border-black tw-border-2"
                >
                  Vet
                </button>
              </div>
            </div>
          )}

          <div className={` ${loggedInUser?.isAdmin ? "relative inline-block" : "tw-hidden"}`}>
            <button
              onClick={handleDropdown}
              className="tw-flex tw-items-center tw-justify-center tw-text-lg tw-text-[#000] tw-font-bold tw-py-1 tw-px-5 tw-rounded-lg tw-border-black tw-border-2"
            >
              {result?.kitId?.subscription} <span className="ml-2">&#x25BE;</span>
            </button>

            {dropdownOpen && (
              <ul className="absolute z-50 mt-2 py-1 bg-white border rounded-lg transform translate-y-full">
                <li
                  onClick={() => handleSubscriptionSelect(selectedSubscription, result?.kitId?._id)}
                  className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                >
                  <span className="tw-text-[#000] tw-font-bold">{selectedSubscription}</span>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
      <PopUp handleClose={handleClose} open={open} result={result} />
      <PetDetailsModel
        handlePetModelClose={handlePetModelClose}
        open={showPetModel}
        // result={result}
      />
      <CareTeamModel
        setShowVetModel={setShowVetModel}
        showVetModel={showVetModel}
        userId={userId}
        showButtons={false}
      />
    </div>
  );
};

export default LabResultMobile;
